import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Invoice } from '@modules/invoice/entities';
import { ZipDownloadService } from '@modules/invoice/services';
import { PdfZoomComponent } from '@shared/pdf-zoom/pdf-zoom.component';
import { ZoomComponent } from '@shared/zoom/zoom.component';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-invoice-viewer-component',
  templateUrl: './invoice-viewer-component.component.html',
  styleUrls: ['./invoice-viewer-component.component.scss']
})
export class InvoiceViewerComponentComponent {
  @Input() invoice!: Invoice;
  @Input() page!: number;
  @Input() isFullScreen!: boolean;
  @Input() dropdownCurrentPage!: number;
  @Input() pageLegnthDropdown!: any[];
  @Input() carouselOptions!: OwlOptions;

  @Input() buttonColor: string = '';

  @Output() pageChanged = new EventEmitter<{ page: number, isPrevious?: boolean }>();
  @Output() fullScreenToggle = new EventEmitter<any>();

  @ViewChild(ZoomComponent) zoomComponent?: ZoomComponent;
  @ViewChild(PdfZoomComponent) pdfZoomComponent?: PdfZoomComponent;

  constructor(private zipDownloadService: ZipDownloadService) { }

  get invoiceDownloadName(): string {
    return this.zipDownloadService.buildInvoiceDownloadName(this.invoice?.sellerName, this.invoice?.number, this.invoice?.date);
  }

  get isImagePage(): boolean {
    const type = this.invoice?.typeAtPage?.(this.page);
    return typeof type === 'string' && type.includes('image');
  }

  endDrag() {
    this.zoomComponent?.endDrag();
    this.pdfZoomComponent?.endDrag();
  }

  onChangePage(newPage: number, isPrevious = false) {
    this.pageChanged.emit({ page: newPage, isPrevious });
  }

  onFullScreenToggle(event: any) {
    this.fullScreenToggle.emit(event);
  }


}
